import { makeStyles } from "tss-react/mui"
import { lightBlue } from "../../../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing, mixins }) => ({
  // a11y: ordered list (root → leaf). list-style + padding reset so the
  // <ol> looks like the original flex row without default bullet/indent.
  breadcrumbsContainer: {
    padding: spacing(2, 1, 1, 1),
    margin: 0,
    listStyle: "none",
    color: lightBlue[700],
    display: "flex",
    alignItems: "center",
    gap: spacing(1),
    flexWrap: "wrap"
  },
  // a11y: each <li> wraps its separator + crumb so the list item count
  // matches the number of crumbs (not 2× because of the separators).
  breadcrumbListItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: spacing(1)
  },
  breadcrumbItem: {
    display: "flex",
    alignItems: "center",
    padding: 0,
    margin: 0,
    minHeight: "unset",
    border: "none",
    background: "transparent",
    verticalAlign: "baseline",
    textAlign: "inherit",
    lineHeight: "inherit",

    "&.MuiLink-button": {
      padding: 0
    },

    "&:focus-visible": {
      ...mixins.focusRing.ring
    }
  }
}))
